"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lender = void 0;
var joi_1 = __importDefault(require("joi"));
exports.lender = joi_1.default.object({
    approvedLenderCode: joi_1.default.string()
        .min(0)
        .max(5)
        .required(),
    approvedLenderName: joi_1.default.string()
        .min(0)
        .max(30)
        .required(),
    approvedLenderReferenceNumber: joi_1.default.string()
        .min(0)
        .max(20)
        .required(),
    financialInstitutionCode: joi_1.default.string()
        .min(0)
        .max(3)
        .required(),
    contactEmail: joi_1.default.string()
        .min(0)
        .max(80)
        .required(),
    contactName: joi_1.default.string()
        .min(0)
        .max(35)
        .allow('')
        .optional(),
    contactPhoneNumber: joi_1.default.string()
        .min(0)
        .max(10)
        .allow('')
        .optional(),
    contactPhoneNumberExtension: joi_1.default.string()
        .min(0)
        .max(10)
        .allow('')
        .optional(),
    transitNumber: joi_1.default.string()
        .min(0)
        .max(5)
        .required(),
});
exports.default = { lender: exports.lender };
